export default __webpack_public_path__ + "static/media/CalciumDecrease.c6345e13.png";